import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';


/**
 * Route guard function that checks if the user is authenticated before allowing access to a route.
 * If the user is not authenticated, it redirects them to the login page and includes a query
 * parameter with the return URL so they can be redirected back after successful login.
 *
 * @param _route
 * @param state
 * @author sadatmalik
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isAuthenticated()) {
    return true;
  }
  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url },
  });
};
